import { render } from "./ClientDescription.vue?vue&type=template&id=20a986b5"
import script from "./ClientDescription.vue?vue&type=script&lang=js"
export * from "./ClientDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__